import { Outlet, Navigate } from 'react-router-dom';
import { useAuthStore } from '../stores/auth';
import { Loader2 } from 'lucide-react';
import { Logo } from '../components/Logo';

export function AuthLayout() {
  const { isAuthenticated, isLoading } = useAuthStore();
  
  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-neutral-50 dark:bg-neutral-900">
        <Loader2 className="w-8 h-8 animate-spin text-accent-600 dark:text-accent-400" />
      </div>
    );
  }
  
  if (isAuthenticated) {
    return <Navigate to="/" replace />;
  }
  
  return (
    <div className="min-h-screen bg-neutral-50 dark:bg-neutral-900 flex flex-col items-center justify-center p-4">
      {/* Logo */}
      <div className="mb-8 text-center">
        <Logo height={40} />
      </div>
      
      <Outlet />
    </div>
  );
}
